
import {
  Box, Button, Grid, IconButton, InputAdornment, makeStyles, Paper,
  Snackbar, TablePagination, TextField, Typography
} from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import {
  styled, Table, TableBody, TableContainer,
  TableHead, TableRow, TableSortLabel
} from '@mui/material';
import * as React from 'react';
import '../App.css';
//Icons
import Backdrop from '@material-ui/core/Backdrop';
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from '@mui/icons-material/Close';
import PuffLoader from "react-spinners/PuffLoader";
import LoadMore from '../images/Icons/LoadMore.svg';
//Models
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { useEffect, useRef, useState } from 'react';
import { Columns } from '../models/Inquiry/config';
import { IDebtor } from '../models/Inquiry/IDebtor';
import { GlobalStateAction, useGlobalState } from '../store/GlobalStore';
import { useFetch, usePost } from '../utils/apiHelper';
//Components
import Autocomplete from '@material-ui/lab/Autocomplete';
import Footer from '../components/Footer/Footer';
import ImpactSearchEmptyState from '../components/ImpactSearch/ImpactSearchEmptyState';
import ExpandableRow from '../components/Inquiry/ExpandableRow';
import VideoPlayer from '../components/YouTubePlayer/VideoPlayer';
import { IImpactSearchResult, ImpactSearchMessages, ImpactSearchState, mapImpactDebtorToRow } from '../models/ImpactSearch/IImpactSearch';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  searchBox: {
    marginTop: '2px',
    borderRadius: "30px",
    border: '2px solid #215176',
    height: '38px',
    textIndent: '10px',
    boxShadow: '0px 1px 4px 1px rgba(103, 128, 159, 1)',
    // boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  div: {
    flexGrow: 1,
    padding: '8px'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  tableHeader: {
    overflow: 'wrap',
    whiteSpace: 'pre-wrap',
    textAlign: 'left',
    background: "#007FFF",
  },
  textStyle: {
    marginTop: '5px',
    marginLeft: '5px',
    float: 'left'
  },
  cssFocused: {
    borderColor: 'white',
    borderWidth: '1px',
  },
  notchedOutline: {
    borderWidth: '1px',
    borderColor: 'white',
  },
  dropDownStyle: {
    marginTop: '2px',
    boxShadow: '0px 1px 4px 1px rgba(103, 128, 159, 1)',
    borderRadius: 5,
    border: '2px solid #215176',
    backgroundColor: 'white',
    height: '38px',
    fontSize: 12,
    width: '100%'
  },
  loadmorebutton: {
    marginTop: '5px',
    borderRadius: 20,
    textIndent: '5px',
    fontSize: 10,
    fontWeight: 'bold',
    marginRight: '40px'
  },
  tablebody: {
    maxHeight: 470,
    minHeight: 470,
    marginTop: '5px',
    [theme.breakpoints.up('lg')]: {
      maxHeight: 'calc( 100vh - 215px)',
      minHeight: 'calc( 100vh - 215px)',
    },
  },
  videoplayer: {
    marginTop: '45px',
    float: 'right'
  },
  videoplayerStyle: {
    marginTop: '9px',
    marginRight: '0px'
  },
  image: {
    width: '17px',
    height: '17px',
    display: 'flex',
  },
  paper1: {
    border: "2px solid black",
    fontSize: 12
  },
  outlinedInput: {
    fontSize: 15,
    color: "black",
    marginTop: '-3px',
    '&$focused $notchedOutline': {
      color: 'white',
      border: '0px'
    },
  },
  outlinedInput1: {
    fontSize: 13,
    color: "black",
    padding: '6px 30px 6px 10px !important',
    '&$focused $notchedOutline': {
      color: 'white',
      border: 'none',
    },
  },
  autoCompleteFont: {
    fontSize: 13,
    padding: '4px 12px'
  },
  notchedOutline1: {
    color: 'white',
    border: '0px'
  },
  notchedOutline2: {
    color: 'white',
    border: 'none',
  },
  IconSizeStyle: {
    height: '10px',
    width: '10px'
  },
  caption: {
    padding: 8,
    fontSize: 12
  },
  footer: {
    marginTop: '15px',
    float: 'right',
    marginRight: '50px'
  },
  norecord: {
    color: "red",
    marginTop: "10px",
    textAlign: 'center'
  },
  fontsize: {
    fontSize: 13
  },
  gridView: {
    // padding: '4px 5px 0px 0px'
    padding: '7px 0px 3px 4px'
  },
  SearchDropdown: {
    marginLeft: '4px'
  },
  footerStyle: {
    display: 'flex', alignContent: "flex-end", justifyContent: "flex-end", width: "70%"
  },
  paginationStyle: {
    display: 'flex', alignContent: "flex-center", justifyContent: "flex-center", width: "30%"
  }
}))

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    background: "#007FFF",
    color: theme.palette.common.white,
    padding: '1px 1px',
    fontSize: 10,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    padding: 0
  }
}));

export default function ComparatorSortingGrid() {
  const { state, dispatch } = useGlobalState();
  const [selected, setSelected] = React.useState<string>();
  const [debtors, setDebtors] = useState<IDebtor[]>([]);
  const [searchDebtor, setSearchDebtor] = useState<string>('');
  const [searchAccountNumber, setSearchAccountNumber] = useState<string>('');
  const [searchDebtorNumber, setSearchDebtorNumber] = useState<string>('');
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(15);
  const [orderBy, setOrderBy] = useState<string>("");
  const [order, setOrder] = useState<any>('asc');
  const [loadAll, setLoadAll] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const userName = state.userAccessContext?.id;
  const video = 'fGytSy2wS-o';
  const title = 'A.R.M. WebView: Searching & Updating Accounts';
  const classes = useStyles();
  const [ProgressBar, setshowProgressBar] = useState(true);
  const [FieldToSearchValue, setFieldToSearchValue] = useState("");
  const fieldToSearchRef = useRef("");
  const [activeSearchBox, setActiveSearchBox] = useState<'account' | 'debtor' | 'all' | null>(null);
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const [showAccountSearchIcon, setShowAccountSearchIcon] = useState(true);
  const [showDebtorSearchIcon, setShowDebtorSearchIcon] = useState(true);
  const prevDBTNo = useRef("");
  const [impactSearchState, setImpactSearchState] = useState<ImpactSearchState>('idle');
  const [isImpactCancelling, setIsImpactCancelling] = useState(false);
  const [impactSnackbar, setImpactSnackbar] = useState<{ open: boolean, severity: 'success' | 'info' | 'warning' | 'error', message: string }>({ open: false, severity: 'info', message: '' });
  const impactPollRef = useRef<any>(null);
  const impactRequestIdRef = useRef<string>('');
  const IMPACT_POLL_INTERVAL = 5000;
  const IMPACT_POLL_TIMEOUT = 180000;

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleRowClick = (accountId: string) => {
    setSelected(selected == accountId ? "" : accountId);
    prevDBTNo.current = accountId;
  }

  const getActiveSearchText = (): string => {
    const activeSearch = searchAccountNumber?.trim() || searchDebtorNumber?.trim() || searchDebtor?.trim();
    return activeSearch?.split(" ")[0] ?? "";
  }

  const stopImpactPolling = () => {
    if (impactPollRef.current) {
      clearInterval(impactPollRef.current);
      impactPollRef.current = null;
    }
  }

  // Cancels the in-flight ADF job (if any) and confirms it to the user — used
  // when the user clears the search boxes or starts a new search while one is
  // running, so the pipeline run doesn't keep consuming the integration runtime.
  const cancelImpactJob = () => {
    if (impactRequestIdRef.current) {
      const requestId = impactRequestIdRef.current;
      impactRequestIdRef.current = '';
      usePost<IImpactSearchResult>("CancelImpactSearch", { "requestId": requestId }).catch(() => { });
      setImpactSnackbar({ open: true, severity: 'info', message: ImpactSearchMessages.cancelled });
    }
  }

  const closeImpactSnackbar = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setImpactSnackbar(previous => ({ ...previous, open: false }));
  }

  const showImpactError = () => {
    setImpactSearchState('error');
    setImpactSnackbar({ open: true, severity: 'error', message: ImpactSearchMessages.error });
  }

  const startImpactPolling = (requestId: string) => {
    const startedAt = Date.now();
    stopImpactPolling();
    impactPollRef.current = setInterval(async () => {
      if (Date.now() - startedAt > IMPACT_POLL_TIMEOUT) {
        stopImpactPolling();
        cancelImpactJob();
        showImpactError();
        return;
      }
      await useFetch<IImpactSearchResult>("GetImpactSearchStatus?requestId=" + requestId).then((statusResult) => {
        const status = statusResult.data?.status;
        if (status === 'Succeeded-RecordsFound') {
          stopImpactPolling();
          impactRequestIdRef.current = '';
          // Feed the IMPACT rows through the existing grid so ExpandableRow /
          // InquiryDetail handle them exactly like local search results.
          const impactRows: IDebtor[] = (statusResult.data?.records ?? []).map(mapImpactDebtorToRow);
          setDebtors(impactRows);
          setTotalRecords(impactRows.length);
          setImpactSearchState('idle');
          setImpactSnackbar({ open: true, severity: 'success', message: ImpactSearchMessages.success });
        } else if (status === 'Succeeded-NoRecords') {
          stopImpactPolling();
          impactRequestIdRef.current = '';
          setImpactSearchState('noRecords');
          setImpactSnackbar({ open: true, severity: 'warning', message: ImpactSearchMessages.noRecords });
        } else if (status === 'Cancelled') {
          stopImpactPolling();
          impactRequestIdRef.current = '';
          setImpactSearchState('idle');
          setImpactSnackbar({ open: true, severity: 'info', message: ImpactSearchMessages.cancelled });
        } else if (status === 'Failed' || status === 'TimedOut' || status === 'Invalid') {
          stopImpactPolling();
          impactRequestIdRef.current = '';
          showImpactError();
        }
      }).catch(() => {
        // Transient polling errors are ignored; the timeout above is the backstop.
      });
    }, IMPACT_POLL_INTERVAL);
  }

  const handleCancelImpactSearch = async () => {
    if (!impactRequestIdRef.current || isImpactCancelling) {
      return;
    }
    setIsImpactCancelling(true);
    stopImpactPolling();
    const requestId = impactRequestIdRef.current;
    impactRequestIdRef.current = '';
    await usePost<IImpactSearchResult>("CancelImpactSearch", { "requestId": requestId }).catch(() => {
      // Even if the cancel call fails, the user asked to stop waiting.
    }).finally(() => {
      setIsImpactCancelling(false);
      setImpactSearchState('idle');
      setImpactSnackbar({ open: true, severity: 'info', message: ImpactSearchMessages.cancelled });
    });
  }

  const handleImpactSearch = async () => {
    if (impactSearchState === 'searching') {
      return;
    }
    setImpactSearchState('searching');
    setImpactSnackbar({ open: true, severity: 'info', message: ImpactSearchMessages.searching });
    let request = {
      "userId": userName,
      "searchParameterType": fieldToSearchRef.current,
      "searchText": getActiveSearchText()
    }
    await usePost<IImpactSearchResult>("SearchImpactSystem", request).then((searchResult) => {
      const data = searchResult.data;
      if (data?.requestId && (data.status === 'Pending' || data.status === 'Running')) {
        impactRequestIdRef.current = data.requestId;
        startImpactPolling(data.requestId);
      } else {
        showImpactError();
      }
    }).catch(() => {
      showImpactError();
    });
  }

  const handleModifyImpactSearch = () => {
    const searchBoxId = activeSearchBox === 'account' ? 'search-account-number'
      : activeSearchBox === 'debtor' ? 'search-debtor-number' : 'search-all-columns';
    document.getElementById(searchBoxId)?.focus();
  }

  useEffect(() => {
    return () => stopImpactPolling();
  }, [])

  const initiateSearch = () => {
    setTriggerSearch(!triggerSearch);
    setshowProgressBar(true);
    setPageNumber(0);
  }

  const createSortHandler = (property) => (event) => {
    const isAsc = orderBy === property && order === 'asc';
    setPageNumber(0);
    setshowProgressBar(true);
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handlePageChange = (event, page) => {
    setPageNumber(page);
    setshowProgressBar(true);
  }

  const cancelSearch = () => {
    stopImpactPolling();
    cancelImpactJob();
    setImpactSearchState('idle');
    setSearchDebtor("");
    setSearchAccountNumber("");
    setSearchDebtorNumber("");
    fieldToSearchRef.current = "";
    setFieldToSearchValue("");
    setActiveSearchBox(null);
    setPageNumber(0);
    setshowProgressBar(true);
    clearSearchText();
    setShowSearchIcon(true);
    setShowAccountSearchIcon(true);
    setShowDebtorSearchIcon(true);
  }

  const FieldToSearch = [
    { title: 'Search All', value: "" },
    { title: 'Client', value: "DBT_CLIENT" },
    { title: 'Agency ID', value: "DBT_NO" },
    { title: 'Account ID', value: "DBT_CLNT_ACNT1" },
    { title: 'Account ID 2', value: "DBT_CLNT_ACNT2" },
    { title: 'Old Account ID', value: "DBT_FLD_24" },
    { title: 'Name', value: "DBT_NAME" },
    { title: 'Email Address', value: "DEM_EMAIL" },
    { title: 'Phone', value: "DEM_PHONE1" },
    { title: 'Tax ID', value: "DEM_TAX_ID" },
    { title: 'Address 1', value: "DEM_ADDR1" },
    { title: 'Address 2', value: "DEM_ADDR2" },
    { title: 'City', value: "DEM_CITY" },
    { title: 'State', value: "DEM_STATE" },
    { title: 'Zip', value: "DEM_ZIP" },
  ];

  const handleChange = (event, selectedvalue) => {
    const val = selectedvalue === "" || selectedvalue === null ? "" : selectedvalue.value;
    fieldToSearchRef.current = val;
    setFieldToSearchValue(val);
    if (activeSearchBox) {
      initiateSearch();
    }
  };

  const handleAccountNumberChange = (value: string) => {
    setSearchAccountNumber(value);
    setSearchDebtorNumber("");
    setSearchDebtor("");
    setActiveSearchBox('account');
  }

  const handleDebtorNumberChange = (value: string) => {
    setSearchDebtorNumber(value);
    setSearchAccountNumber("");
    setSearchDebtor("");
    setActiveSearchBox('debtor');
  }

  const handleAllColumnsChange = (value: string) => {
    setSearchDebtor(value);
    setSearchAccountNumber("");
    setSearchDebtorNumber("");
    setActiveSearchBox('all');
  }

  const initiateAccountSearch = () => {
    const type = fieldToSearchRef.current || "DBT_CLNT_ACNT1";
    fieldToSearchRef.current = type;
    setFieldToSearchValue(type);
    setActiveSearchBox('account');
    setShowAccountSearchIcon(false);
    setShowSearchIcon(true);
    setShowDebtorSearchIcon(true);
    initiateSearch();
  }

  const initiateDebtorSearch = () => {
    const type = fieldToSearchRef.current || "DBT_NO";
    fieldToSearchRef.current = type;
    setFieldToSearchValue(type);
    setActiveSearchBox('debtor');
    setShowDebtorSearchIcon(false);
    setShowSearchIcon(true);
    setShowAccountSearchIcon(true);
    initiateSearch();
  }

  const initiateAllColumnsSearch = () => {
    setActiveSearchBox('all');
    setShowSearchIcon(false);
    setShowAccountSearchIcon(true);
    setShowDebtorSearchIcon(true);
    initiateSearch();
  }

  const cancelAccountSearch = () => {
    stopImpactPolling();
    cancelImpactJob();
    setImpactSearchState('idle');
    setSearchAccountNumber("");
    fieldToSearchRef.current = "";
    setFieldToSearchValue("");
    setActiveSearchBox(null);
    setShowAccountSearchIcon(true);
    setPageNumber(0);
    setshowProgressBar(true);
    clearSearchText();
  }

  const cancelDebtorSearch = () => {
    stopImpactPolling();
    cancelImpactJob();
    setImpactSearchState('idle');
    setSearchDebtorNumber("");
    fieldToSearchRef.current = "";
    setFieldToSearchValue("");
    setActiveSearchBox(null);
    setShowDebtorSearchIcon(true);
    setPageNumber(0);
    setshowProgressBar(true);
    clearSearchText();
  }

  async function clearSearchText() {
    let request = {
      "userId": userName,
      "searchText": "",
      "searchType": "",
      "orderBy": orderBy,
      "orderDirection": order,
      "rowsPerPage": recordsPerPage,
      "startingRecordNumber": (pageNumber * recordsPerPage) + 1,
      "viewall": loadAll
    }
    dispatch({ type: GlobalStateAction.Busy });
    await usePost<{ debtors: IDebtor[], totalRecordCount: number }>("SearchDebtorInquiry", request).then((searchDebtor) => {
      setDebtors(searchDebtor.data["debtors"]);
      setTotalRecords(searchDebtor.data.totalRecordCount);
    }).finally(() => {
      setshowProgressBar(false);
    });
  }

  useEffect(() => {
    stopImpactPolling();
    cancelImpactJob();
    setImpactSearchState('idle');
    (async () => {
      const activeSearch = searchAccountNumber?.trim() || searchDebtorNumber?.trim() || searchDebtor?.trim();
      let request = {
        "userId": userName,
        "searchText": activeSearch?.split(" ")[0] ?? "",
        "searchType": fieldToSearchRef.current,
        "orderBy": orderBy,
        "orderDirection": order,
        "rowsPerPage": recordsPerPage,
        "startingRecordNumber": (pageNumber * recordsPerPage) + 1,
        "viewall": loadAll
      }
      await usePost<{ debtors: IDebtor[], totalRecordCount: number }>("SearchDebtorInquiry", request).then((searchDebtor) => {
        setDebtors(searchDebtor.data["debtors"]);
        setTotalRecords(searchDebtor.data.totalRecordCount);
      }).finally(() => {
        setshowProgressBar(false);
      });
    })()
  }, [pageNumber, triggerSearch, loadAll, orderBy, order])

  return (
    <div className={classes.div}>
      <Backdrop className={classes.backdrop} open={ProgressBar}>
        <PuffLoader size={80} color={"white"} speedMultiplier={1} />
      </Backdrop>
      <Grid container spacing={2} className={classes.gridView}>
        <Box component="span" m={0} width="13%" >
          <Typography variant="h5" gutterBottom className={`${classes.textStyle} ${"headertitle"}`}>
            <b>INQUIRY LIST</b>
          </Typography>
        </Box>
        <Box component="span" m={0} width="20%" >
          <TextField
            fullWidth
            size="small"
            id="search-account-number"
            variant="outlined"
            value={searchAccountNumber}
            className={classes.searchBox}
            type='text'
            placeholder="Account Number"
            onChange={e => handleAccountNumberChange(e.target.value)}
            onKeyPress={event => {
              if (event.key === 'Enter' && searchAccountNumber !== "") {
                initiateAccountSearch();
              } else if (event.key === 'Enter' && searchAccountNumber === "") {
                cancelAccountSearch();
              }
            }}
            inputProps={{ maxLength: 255 }}
            InputProps={{
              classes: {
                root: classes.outlinedInput,
                notchedOutline: classes.notchedOutline1,
              },
              endAdornment: (
                <InputAdornment position="end">
                  {showAccountSearchIcon ?
                    <IconButton onClick={() => { if (searchAccountNumber) initiateAccountSearch(); }} style={{ padding: '5px' }}>
                      <SearchIcon />
                    </IconButton>
                    :
                    <IconButton onClick={cancelAccountSearch} style={{ padding: '5px' }}>
                      <CloseIcon />
                    </IconButton>
                  }
                </InputAdornment>
              )
            }}
          />
        </Box>
        <Box component="span" m={0} width="20%" >
          <TextField
            fullWidth
            size="small"
            id="search-debtor-number"
            variant="outlined"
            value={searchDebtorNumber}
            className={classes.searchBox}
            type='text'
            placeholder="Debtor Number"
            onChange={e => handleDebtorNumberChange(e.target.value)}
            onKeyPress={event => {
              if (event.key === 'Enter' && searchDebtorNumber !== "") {
                initiateDebtorSearch();
              } else if (event.key === 'Enter' && searchDebtorNumber === "") {
                cancelDebtorSearch();
              }
            }}
            inputProps={{ maxLength: 255 }}
            InputProps={{
              classes: {
                root: classes.outlinedInput,
                notchedOutline: classes.notchedOutline1,
              },
              endAdornment: (
                <InputAdornment position="end">
                  {showDebtorSearchIcon ?
                    <IconButton onClick={() => { if (searchDebtorNumber) initiateDebtorSearch(); }} style={{ padding: '5px' }}>
                      <SearchIcon />
                    </IconButton>
                    :
                    <IconButton onClick={cancelDebtorSearch} style={{ padding: '5px' }}>
                      <CloseIcon />
                    </IconButton>
                  }
                </InputAdornment>
              )
            }}
          />
        </Box>
        <Box component="span" m={0} width="20%" >
          <TextField
            fullWidth
            size="small"
            id="search-all-columns"
            variant="outlined"
            value={searchDebtor}
            className={classes.searchBox}
            type='text'
            placeholder="Search All Columns"
            onChange={e => handleAllColumnsChange(e.target.value)}
            onKeyPress={event => {
              if (event.key === 'Enter' && searchDebtor !== "") {
                initiateAllColumnsSearch();
              } else if (event.key === 'Enter' && searchDebtor === "") {
                cancelSearch();
              }
            }}
            inputProps={{ maxLength: 255 }}
            InputProps={{
              classes: {
                root: classes.outlinedInput,
                notchedOutline: classes.notchedOutline1,
              },
              endAdornment: (
                <InputAdornment position="end">
                  {showSearchIcon ?
                    <IconButton onClick={() => { if (searchDebtor) initiateAllColumnsSearch(); }} style={{ padding: '5px' }}>
                      <SearchIcon />
                    </IconButton>
                    :
                    <IconButton onClick={cancelSearch} style={{ padding: '5px' }}>
                      <CloseIcon />
                    </IconButton>
                  }
                </InputAdornment>
              )
            }}
          />
        </Box>
        <Box component="span" m={0} width="13%" >
          <Autocomplete
            size="small"
            id="I_DropDown"
            className={classes.SearchDropdown}
            classes={{
              paper: classes.paper1,
              option: classes.autoCompleteFont
            }}
            options={FieldToSearch}
            defaultValue={FieldToSearch[0]}
            disableClearable={true}
            onChange={handleChange}
            getOptionLabel={(option) => option.title}
            renderInput={(params) =>
              <TextField
                placeholder="Search Fields"
                {...params}
                className={classes.dropDownStyle}
                InputProps={{
                  ...params.InputProps, disableUnderline: true,
                  classes: {
                    root: classes.outlinedInput1
                  }
                }}
              />}
          />
        </Box>
        {state?.userAccessContext?.role === 2 || state?.userAccessContext?.role === 3 ?
          <Box component="span" m={0} width="13%" style={{ float: 'right' }}>
            <Button id="Inquiry_LoadAll_Button" className={classes.loadmorebutton}
              variant="contained" disabled={loadAll} color="primary"
              onClick={(_) => { setLoadAll(true); setshowProgressBar(true); }} >
              <img src={LoadMore} alt="Load_More" className={classes.image} />
              Load More
            </Button>
            <Box className={classes.videoplayerStyle} >
              {/* <VideoPlayer video={videoFile} title={videoPlacementTitle} /> */}
            </Box>
          </Box>
          : <Box width="13%" className={classes.videoplayer}>
            {/* <VideoPlayer video={videoFile} title={videoPlacementTitle} /> */}
          </Box>
        }
      </Grid>
      <Paper>
        <TableContainer component={Paper} className={`${classes.tablebody} ${"scrollbox"} ${"on-scrollbar"}`}>
          <Table sx={{ minWidth: 650 }} aria-label="customized table" size="small" stickyHeader>
            <TableHead className={classes.tableHeader}>
              <TableRow>
                {Columns.map((headCell) => (
                  <StyledTableCell
                    align={headCell.type == "string" ? "left" : "left"}
                    key={headCell.id}
                    style={{ width: `${headCell.width}` }}
                    sortDirection={orderBy === headCell.id ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : 'asc'}
                      onClick={createSortHandler(headCell.id)}
                    >
                      {headCell.field}
                      {orderBy === headCell.id ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                debtors.map(r => <ExpandableRow onClick={handleRowClick} selected={selected === r.dbT_NO} key={r.dbT_NO} row={r} selectedDBTNumber={selected} searchWord={searchDebtor} />)
              }
            </TableBody>
          </Table>
          {!ProgressBar && !debtors.length ?
            (getActiveSearchText() !== "" ?
              <ImpactSearchEmptyState
                searchText={getActiveSearchText()}
                canSearchImpact={!!fieldToSearchRef.current}
                searchState={impactSearchState}
                isCancelling={isImpactCancelling}
                onSearchImpact={handleImpactSearch}
                onModifySearch={handleModifyImpactSearch}
                onCancelSearch={handleCancelImpactSearch}
              />
              : <Typography variant="h6" gutterBottom className={classes.norecord}>
                No records to display...
              </Typography>)
            : null}
        </TableContainer>
        <Grid container spacing={0}>
          <Grid item xs={6} sm={9} className={classes.footerStyle} >
            <div className={classes.footer}>
              <Footer />
            </div>
          </Grid>
          <Grid item xs={6} sm={3} className={classes.paginationStyle} >
            <TablePagination
              id="Inquiry_TablePagination"
              rowsPerPageOptions={[15]}
              component="div"
              count={totalRecords}
              rowsPerPage={15}
              page={pageNumber}
              onChangePage={handlePageChange}
            />
          </Grid>
        </Grid>
      </Paper>
      <Snackbar className="snackBarStyle" open={impactSnackbar.open} anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }} autoHideDuration={6000} onClose={closeImpactSnackbar}>
        <Alert onClose={closeImpactSnackbar} severity={impactSnackbar.severity} className="alertStyle">
          {impactSnackbar.message}
        </Alert>
      </Snackbar>
    </div >
  )
}